export const getItems = state => state.cadTipos.items;

export default {
	getItems,
};
